module.exports = __webpack_public_path__ + "img/efficiency3.4a4004b5.png";